export type SecretaryResponsibleMode = 'existing' | 'manual';

interface SecretaryResponsiblePayloadOptions {
  payload: Record<string, any>;
  mode: SecretaryResponsibleMode;
  isEditing: boolean;
  selectedUserIds: number[];
}

export const applySecretaryResponsiblePayload = ({
  payload,
  mode,
  isEditing,
  selectedUserIds,
}: SecretaryResponsiblePayloadOptions) => {
  const params = { ...payload };
  const [primaryUserId, ...additionalUserIds] = selectedUserIds;

  if (!isEditing && mode === 'existing') {
    params.responsible_user_id = primaryUserId;
    params.additional_responsible_user_ids = additionalUserIds;
    delete params.responsible;
    delete params.email;
    delete params.responsible_phone;
    delete params.function;
    return params;
  }

  delete params.responsible_user_id;
  delete params.additional_responsible_user_ids;

  if (isEditing) {
    params.existing_user_ids = selectedUserIds;
  }

  return params;
};
